/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { IConfigurationModel } from "@nf/common";
import React, { PropsWithChildren, useMemo } from "react";

import Layout from "layouts/Layout";
import BackButton from "components/BackButton";

import styles from "./DetailsLayout.module.scss";

interface DetailsLayoutProps {
  config: IConfigurationModel;
}

const DetailsLayout = ({
  children,
  config,
}: PropsWithChildren<DetailsLayoutProps>) => {
  const header = useMemo(
    () => ({
      visibility: { phone: true, tablet: true, desktop: true, large: true },
      logo: {
        show: true,
        visibility: {
          phone: false,
          tablet: false,
          desktop: true,
          large: true,
        },
      },
      dropdown: {
        show: false,
      },
      menu: {
        show: true,
        visibility: {
          phone: false,
          tablet: false,
          desktop: true,
          large: true,
        },
      },
      search: {
        show: true,
        visibility: {
          phone: false,
          tablet: false,
          desktop: true,
          large: true,
        },
      },
      userInfo: {
        show: true,
        visibility: {
          phone: false,
          tablet: false,
          desktop: true,
          large: true,
        },
      },
      custom: {
        left: <BackButton className={styles.back} />,
      },
    }),
    []
  );

  return (
    <Layout className={styles.layout} config={config} navigation={header}>
      {children}
    </Layout>
  );
};

export default DetailsLayout;
